<template>
    <div class="Experimentlist">
        <el-row>
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="contentl">
                    <p class="tit">
                        回收站
                    </p>
                    <ul>
                        <li>
                            <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto" class="input-with-select" @change="closeSearch">
                                    <el-button slot="append" @click="searchto"><i class="magnifier"></i></el-button>
                                    <el-button slot="append" @click="Rescreening" style="border-left:1px solid #DCDFE6;"><i class="refresh"></i></el-button>
                            </el-input>
                        </li>
                    </ul>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin:10px;">
            <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                <div class="list" v-if="itemOk">
                    <div class="noshow" v-if="dataList==''">
                        <span>当前回收站为空</span>
                        <p><img src="../../assets/images/portal/noex.png" alt=""></p>
                    </div>
                    <el-row :gutter="20" v-else>
                        <div class="list-nav">
                            <ul>
                                <li style="background-color:#38B3F3;color:#fff;" @click="reductionBtn">还原实验</li>
                                <li style="border-color:#ccc;color:#ccc;pointer-events:none" class="deleteS" @click="deleteSelection">删除选中</li>
                                <li style="width: 112px;border-color:#F38F38;color:#F38F38;" @click="empty">清空回收站</li>
                            </ul>
                        </div>
                            <el-col :xs="12" :sm="6" :lg="6" :xl="6" v-for="(item,index) in dataList" :key="index" v-loading="loading" class="item">
                                <div class="itemIn">
                                    <div class="pic">
                                        <el-image fit="cover" :src="imageChanges[index]" :title="item.syname" style="background-color:#1d1d1d;">
                                            <div slot="error" class="image-slot">
                                                <img src="../../assets/images/portal/nophoto.png">
                                            </div>
                                        </el-image>
                                        <div class="tbtj" v-if="item.isStudy != null">
                                            <b class="left-top">{{isStudy}}</b>
                                        </div>
                                        <div v-else></div>
                                    </div>
                                    <div class="pick">
                                        <el-checkbox-group v-model="checkedCount" @change="handleCheckedChange" class="checkbox-group">
                                            <el-checkbox class="checkBOxItem" :key="item.id" :label="item.id">
                                            </el-checkbox>
                                        </el-checkbox-group>
                                        <h5 class="titl" :title="item.syname">{{item.syname}}</h5>
                                        <el-dropdown size="small" @command="handleCommand(item)" placement='top'>
                                            <span class="dropdown-more">
                                                <img src="../../assets/images/newimg/more.png" alt="">
                                            </span>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item>删除实验</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                </div>
                            </el-col>
                        <div class="paginations">
                            <el-pagination
                                background
                                hide-on-single-page
                                layout="prev, pager, next"
                                :total="pageData.total"
                                @current-change="pageChange"
                                :current-page.sync="page"
                                :page-size='12'
                                >
                            </el-pagination>
                        </div>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import request from '@/utils/request'
import $ from 'jquery'
// import pubilc from '../publicStyle/public'

export default {
    // props:['src'],
    data(){
        return{
            checkedCount: [],
            itemOk:false,
            isStudy:'探究',
            imageChanges:[],
            userId:'',
            page:0,
            loading:false,
            isfree:'',
            search: '',
            themeType:'',
            materialType:'',
            infoNumber:'',
            // type:'',
            dataList:[{}],
            eduId:'',
            pageData:{
                pagesize:12,
                pagenumber:0,
                total:0,
                average:0,
            },
      }
    },
    components:{
        // pubilc
    },
　　filters: {
　　},
    created(){
        this.getinfo();
    },
    methods:{
        reductionBtn(){
            if(this.checkedCount.length == 0){
                this.$notify({
                    message: '当前无选中的实验，请选择后再试',
                    type: 'error',
                    duration: 1500
                })
            }else{
                this.$confirm('您确定将所选中的实验还原到 我的实验中？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'messageBox-btnF',
                    confirmButtonClass: 'messageBox-btnT',
                    type: 'warning',
                }).then(() => {
                    request({
                        method:'put',
                        url:'api/putRecycle?list='+this.checkedCount
                    }).then(res=>{
                        this.checkedCount = []
                        this.getList();
                    })
                }).catch(() => {
                })
            }
        },
        // 清空
        empty(){
            this.$confirm('您确定清空回收站中所有的实验？ 清空后不可恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'messageBox-btnF',
                confirmButtonClass: 'messageBox-btnT',
                type: 'warning',
            }).then(() => {
                request({
                    method:'delete',
                    url:'api/qkSylistinfo'
                }).then(res=>{
                    this.getList();
                })
            }).catch(() => {
            })
        },
        // 复选
        handleCheckedChange(value) {
            if(value.length > 0){
                $('.deleteS').css({"pointer-events":"unset","border-color":"#F38F38","color":"#F38F38"});
            }else{
                $('.deleteS').css({"pointer-events":"none","border-color":"#ccc","color":"#ccc"});
            }
            this.checkedCount = value;
        },
        // 删除实验
        handleCommand(item){
            if(item.isStudy != null){
                this.Altmsg = '您确定永久删除此实验? 永久删除后不可恢复'
            }else{
                this.Altmsg = '您确定永久删除此文件？永久删除后不可恢复'
            }
            this.$confirm(this.Altmsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                cancelButtonClass: 'messageBox-btnF',
                confirmButtonClass: 'messageBox-btnT',
                type: 'warning',
            }).then(() => {
                request({
                    method:'delete',
                    url:'api/deleteRecycle?list='+item.id
                }).then(res=>{
                    let totalPage = Math.ceil((((this.pageData.total -1) / this.pageData.pagesize)-1).toFixed(0))
                    let currentPage = this.pageData.pagenumber > totalPage ? totalPage : this.pageData.pagenumber
                    this.pageData.pagenumber = currentPage < 0 ? 0 : currentPage
                    this.getList();
                })
            }).catch(() => {
            })
        },
        // 删除选中
        deleteSelection(){
            if(this.checkedCount.length == 0){
                this.$notify({
                    message: '当前无选中的实验，请选择后再试',
                    type: 'error',
                    duration: 1500
                })
            }else{
                this.$confirm('您确定删除所选中的实验？ 删除后不可恢复', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'messageBox-btnF',
                    confirmButtonClass: 'messageBox-btnT',
                    type: 'warning',
                }).then(() => {
                    request({
                        method:'delete',
                        url:'api/deleteRecycle?list='+this.checkedCount
                    }).then(res=>{
                        $('.deleteS').css({"pointer-events":"none","border-color":"#ccc","color":"#ccc"});
                        this.checkedCount = []
                        let totalPage = Math.ceil((((this.pageData.total -1) / this.pageData.pagesize)-1).toFixed(0))
                        let currentPage = this.pageData.pagenumber > totalPage ? totalPage : this.pageData.pagenumber
                        this.pageData.pagenumber = currentPage < 0 ? 0 : currentPage
                        this.getList();
                    })
                }).catch(() => {
                })
            }
        },
        // 清空搜索框-知识点
        closeSearch(val){
            if(val == ''){
                this.searchto();
            }
        },
        //获取info
        getinfo(){
          request({
            method:'get',
            url:'auth/info'
          }).then(res=>{
            this.userId = res.jwtUser.id
            this.getList();
          })
        },
        //按知识点
        Rescreening(){
            this.$confirm('您是否要重置搜索内容？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnT',
            type: 'warning',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList()
            }).catch(() => {
            });
        },
        //按知识点搜索
        searchto(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$notify({
                        message:"此为非法字符，请确认后输入",
                        type:'error',
                        duration: 1500
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList();
        },
        //通过知识点获取
        getList(type){
            this.loading = true
            request({
                 method:'get',
                 url: 'api/jdSylistinfo?eduTreeIds='+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&syuserid='+this.userId+'&noderes=&syname='+this.search+'&sort=id,desc&userCollect=0&syModular=&recycle=1'
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].sypicpath == '' || changeimg[i].sypicpath == null){
                        changeimg[i].sypicpath = '../../assets/images/portal/nophoto.png';
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }else{
                        this.imageChanges.push((changeimg[i].sypicpath.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.loading = false
                this.itemOk = true
                // 滚动到顶部
                let currentPosition,timer;
                let speed=30;
                setTimeout(() => {
                    timer=setInterval(function(){
                        currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                        currentPosition-=speed;
                        if(currentPosition>0){
                            window.scrollTo(0,currentPosition);
                        }else{
                            window.scrollTo(0,0);
                            clearInterval(timer);
                        }
                    },1);
                }, 100)

            })
        },
        pageChange(data){
            this.pageData.pagenumber = data-1;
            this.getList()
        },
    }
    
}
</script>

<style scoped>
    @import '../styles/pad.css';
    @import '../styles/search.css';
    @import '../styles/box.css';
.active{
    border: 2px solid rgb(236, 111, 40);
}
.list-nav{
    padding-left:10px;
    padding-right: 10px;
    float:left;
    width:100%;
    margin-bottom: 12px;
}
.list-nav ul{
    float:left;
    margin: 0;
    padding: 0;
}
.list-nav ul li{
    list-style: none;
    float:left;
    padding: 6px 10px;
    margin-right: 12px;
    text-align: center;
    border-radius: 4px;
    font-size: 16px;
    cursor: pointer;
    border: 2px solid #38B3F3;
}
.list-nav ul li:nth-of-type(1):hover{
    background-color: #3bcaff !important;
    border-color: #3bcaff !important;
}
.list-nav ul li:nth-of-type(2):hover{
    background-color: #F38F38 !important;
    color: #fff !important;
}
.list-nav ul li:nth-of-type(3):hover{
    background-color: #F38F38 !important;
    color: #fff !important;
}
.el-dropdown{
    float:right;
    margin: 0 5px 0 0;
    cursor: pointer;
    margin-top: 15px;
}
.dropdown-more img{
    width: 24px !important;
    height: 6px !important;
}
.list /deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color: #F38F38;
    border-color: #F38F38;
}
.list /deep/ .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#F38F38;
}
.checkbox-group{
    float:left;
    padding-top: 3.2%;
    padding-left: 2%;
}
.checkbox-group > .checkBOxItem /deep/ .el-checkbox__label{
    display: none;
}
.checkBOxItem{
    width: 100%;
    width: 22px;
    height: 22px;
}
.checkBOxItem /deep/ .el-checkbox__label{
    padding-left: 0;
    width:100%;
}
.checkBOxItem /deep/ .el-checkbox__input{
    position: absolute;
    right: 3%;
    top: 5%;
    z-index: 100;
}
.checkBOxItem /deep/ .el-checkbox__inner{
    width: 22px;
    height: 22px;
    border:2px solid #F38F38;
}
.checkBOxItem /deep/ .el-checkbox__inner::after{
    height: 14px;
    width: 6px;
    left: 5px;
    top: 0;
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
}
.pick{
    margin: 0;
    color:#666;
    float:left;
    width:100%;
    margin-bottom:10px;
}
.Experimentlist{
    width: 100%;height: 100%;background: #fff;
    float:left;
}
.contentl{
    width:98%;
    border-bottom: 1px solid #eee;
    height: 65px;
    margin-left: 1%;
    margin-bottom: 10px;
}
.tit{
    margin: 0;
    line-height: 65px;
    font-size: 20px;
    font-weight: 400;
    float: left;
    color: #333;
}
.rowtab2{
    float: left;
    font-size: 14px;
    margin-top: 32px;
    margin-left: 805px;
}
.buttontab2{
    height: 14px;
    padding-right: 10px;
    border-right: 1px solid #ccc;
}
.buttontab2:last-of-type{
    padding-left: 5px;
    border-right: none;
    padding-right: 0;
}
.contentl>ul{
    height: 65px;
    line-height: 65px;
    margin: 0;
    padding: 0;
    list-style: none;
    padding: 0 126px;
    float: right;
}
.contentl>ul>li{
    width: auto;
    float: left;
    margin: 0;
    padding: 0;
    list-style: none;
}
.list{
    width: 100%;
    height: 100%;
    float:left;
}
.item{
    /* width:30%; */
    float: left;
    margin-bottom: 20px;
    z-index: 10;
}
.itemIn{
    width:100%;
    float: left;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
.itemIn:hover{
    transition: all 0.2s linear 0s;
    transform: scale(1.01);
    box-shadow: 4px 7px 18px 0px rgba(0, 0, 0, 0.2);
}
.itemIn:hover .collection{
    display: block;
}
.pic{
    width: 100%;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    height:calc( (23.1vw / 16) * 9);
}
.pic /deep/ .el-image{
    width:100%;
    height: 100%;
    float:left;
}
.pic img{
    width:100%;
    height: 100%;
}
/* 同步 探究 */
.tbtj{
    width: 14%;
    height: 30px;
    line-height: 30px;
    background-color: #00A0E9;
    border-radius: 2px;
    position: absolute;
    left: 3%;
    top: 5%;
    color: #E8E8E8;
    font-size: 18px;
}
.left-top{
    font-weight: 400;
}
/* 收藏 */
.collection{
    width: 12%;
    height: 14.5%;
    position: absolute;
    right: 3%;
    top: 5%;
    background: #fff;
    padding: 8px;
    border-radius: 4px;
    display: none;
    cursor: pointer;
}
.list /deep/ .image-slot{
    width:100%;
    height:100%;
    float: left;
}
.collection-2{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection2.png) !important;
    background-size: 100%;
    animation: spin 0.5s ease-in-out;
}
@keyframes spin {
                0%{
                    transform: scale(1);  /*开始为原始大小*/
                }
                100% {
                    transform: scale(1.1);
                }
            }
.collection>i{
    float: left;
    width: 100%;
    height: 100%;
}
.collectioni{
    width: 100%;
    height: 100%;
    background-image: url(../../assets/images/portal/collection.png);
    background-size: 100%;
}
/* 收费 免费 */
.box{
    width: 0;
    height: 0;
    border-top: 60px solid  #46b8da;
    border-left: 60px solid transparent;
    margin-bottom: -100px;
    position: absolute;
    right: 0;
    top: 0;
    float: right !important;
    box-sizing: border-box;
    z-index: 200;
}
.box2{
    border-top: 60px solid  #f19345;
}
.right-top{
    width: 60px;
    font-weight: 600;
    color: #fff;
    position: relative;
    right: 50px;
    top: -50px;
    display: block;
    box-sizing: border-box;
    /* transform: rotate(80deg); */
    -webkit-transform:rotate(45deg)
}
/* .pic:hover .pichover{
    display: block;
    align-items:center;
    display: -webkit-flex;
    justify-content:center;
    cursor: pointer;
}
.pichover{
    width: 100%;
    height: 100%;
    font-size: 22px;
    font-weight: 600;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    opacity: 0.8;
    display: none;
    transform: all 0.7s;
} */

.titl{
    padding-top: 4%;
    padding-left: 2%;
    font-size: 16px;
    color: #333;
    font-weight: 400;
    width: 60%;
    margin: 0;
    float:left;
    white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
}
.el-rate{
    float: right;
    color:rgb(236, 111, 40)
}
.paginations{
    width: 100%;
    float: left;
    padding: 18px 20px;
}
.el-pagination{
    text-align: center;
    font-weight: 400;
}
/* 提示信息 */
.noshow{
    height: auto;
    text-align: center;
    margin-top: 166px;
}
.noshow>span{
    font-size: 32px;
    color: #999;
}
.noshow>p{
    margin-top: 69px;
    margin-bottom: 158px;
    width: 593px;
    height: 349px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
}
.noshow>p>img{
    width: 100%;
    height: 100%;
}
.isRecomm{
    width: 18px;
    height: 20px;
    float: left;
    margin-right: 9px;
    background-image: url(../../assets/images/portal/hot.png);
    background-size: 100%;
}
.image-slot{
    width: 100%;
    height: 100%;
    float: left;
}
  @media (max-width: 375px){
    .paginations{
        padding: 20px 0;
    }
    .paginations>.el-pagination{
        width: 100%;
        padding: 0;
    }
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 110px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 10px 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 14px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:376px) and (max-width: 768px){
    .pick p:nth-of-type(1){
        width:66%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .pick p:nth-of-type(2){
        width: 100%;
        float: left;
        padding: 0 0 6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 340px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 0 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:769px) and (max-width: 1024px){
    .break{
        display:none;
    }
    .rowtab2{
        position: absolute;
        left: 0px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 360px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 1px 0 0 0;
        padding: 0;
        list-style: none;
        padding: 0;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .break{
        display:none;
    }
    .rowtab2{
        float: left;
        margin-left: 20px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    .pick p:nth-of-type(1){
        width:56%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .pick p:nth-of-type(2){
        width: 44%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 710px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .rowtab2{
        position: absolute;
        left: 200px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 860px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .rowtab2{
        position: absolute;
        left: 600px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
  @media (min-width:2049px){
    .paginations{
        padding: 40px 0;
    }
    .rowtab2{
        position: absolute;
        left: 1150px;
        font-size: 14px;
        margin-top: 32px;
        margin-left: 805px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#F38F38;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .buttontab2>.el-radio-button__inner{
        border: none;
        padding: 0;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__inner:hover{
        color: #F38F38;
    }
    .contentl /deep/ .buttontab2>.el-radio-button__orig-radio:checked+.el-radio-button__inner{
        background: #fff;
        color: #F38F38;
        box-shadow: none;
    }
    .contentl /deep/ .buttontab2:first-child .el-radio-button__inner{
        border-left: none;
    }
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
  }
    [v-cloak] {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/recycle/recycle.vue